module.exports = __webpack_public_path__ + "static/media/bt.a8c715fb.svg";